export default "__VITE_ASSET__DpFYUQjH__"